
import React from "react";
import "../style/PrivacyPolicy.css";

export default function PrivacyPolicy() {
  return (
    <div className="privacy-page">
      <div className="privacy-container">
        <h1 className="privacy-title">Privacy Policy</h1>

        <p className="effective-date">
          <strong>Effective Date:</strong> 14th August, 2026
        </p>

        <p>
          Great Eastern Hire Purchase Private Limited (“Great Eastern”, “we”,
          “our”, or “us”), also operating under the trade name{" "}
          <strong>Great Eastern Trading Company</strong>, values your trust.
          This Privacy Policy explains how we collect, use, share, and
          safeguard your information when you interact with our official
          websites, WhatsApp services, Instagram services, advertisements,
          digital lead forms, customer support channels, or visit our physical
          stores across India.
        </p>

        <p>
          For store location, product inquiries, service requests, sales
          assistance, or support assistance, customers may also contact our
          official WhatsApp support bot at <strong>+918017353535</strong>.
        </p>

        <h2>1. Information We Collect</h2>

        <ul>
          <li>
            <strong>Personal Information:</strong> Name, phone number, email
            address, billing/shipping address, payment details, and
            government-issued IDs (if required for financing, hire purchase,
            warranty, or other legally permitted purposes).
          </li>

          <li>
            <strong>Lead & Inquiry Information:</strong> Information you
            voluntarily provide when submitting an inquiry, requesting a
            callback, interacting with our WhatsApp or Instagram bots,
            responding to advertisements, completing a digital lead form, or
            otherwise expressing interest in our products or services.
          </li>

          <li>
            <strong>Purchase & Service Data:</strong> Products you purchase,
            service/repair requests, warranty information, delivery
            information, and related records.
          </li>

          <li>
            <strong>Device & Usage Data:</strong> IP address, browser type,
            device information, approximate location where technically
            available, website interactions, and other information collected
            through cookies and similar technologies.
          </li>

          <li>
            <strong>WhatsApp & Digital Communications:</strong> Messages,
            queries, responses, lead information, service requests, and other
            communications that you send to us or provide through our digital
            communication channels.
          </li>
        </ul>

        <h2>2. How We Use Your Information</h2>

        <ul>
          <li>To process and fulfil your orders and payments.</li>

          <li>
            To provide product information, quotations, financing information,
            delivery assistance, installation, warranty, and after-sales
            support.
          </li>

          <li>
            To respond to inquiries and requests submitted through our
            website, WhatsApp bot, Instagram bot, advertisements, digital lead
            forms, physical stores, or other official channels.
          </li>

          <li>
            To contact customers by telephone when they have voluntarily
            provided their contact details or initiated an inquiry, lead,
            callback request, product enquiry, advertisement response, or
            similar interaction with Great Eastern.
          </li>

          <li>
            To communicate with you about orders, inquiries, offers, services,
            updates, and relevant products through telephone, website, email,
            SMS, WhatsApp, or other permitted communication channels.
          </li>

          <li>
            To connect customer inquiries with the appropriate Great Eastern
            sales representative, store, service team, or other authorized
            personnel.
          </li>

          <li>
            To improve our products, services, customer support, advertising,
            sales processes, and digital platforms.
          </li>

          <li>
            To detect, prevent, and investigate fraud, misuse, unauthorized
            activity, or security incidents.
          </li>

          <li>
            To comply with applicable legal, regulatory, tax, accounting,
            telecom, and financial requirements.
          </li>
        </ul>

        <h2>3. Customer-Initiated Inquiries, Lead Follow-Up & Sales Calls</h2>

        <p>
          Great Eastern may receive customer inquiries and leads through
          multiple channels, including our website, WhatsApp bot, Instagram
          bot, digital advertisements, social media campaigns, online lead
          forms, physical stores, telephone interactions, and other official
          Great Eastern channels.
        </p>

        <p>
          When you voluntarily provide information such as your name and
          mobile number through any such channel, or otherwise initiate an
          inquiry, product enquiry, callback request, advertisement response,
          or conversation with Great Eastern, you are indicating your interest
          in receiving a response regarding that inquiry or the relevant
          product or service.
        </p>

        <p>
          Accordingly, Great Eastern and its authorized representatives may
          contact you by telephone using the number you provided in order to
          respond to your inquiry, discuss the product or service in which you
          expressed interest, provide a quotation, explain financing or
          purchase options, arrange a store visit, assist with conversion of
          your inquiry into a purchase, or provide related sales assistance.
        </p>

        <p>
          Such contact may be initiated even if the original interaction took
          place through an advertisement, WhatsApp bot, Instagram bot, website,
          digital form, or another Great Eastern lead-generation channel.
        </p>

        <p>
          We may use the information associated with your inquiry to identify
          the relevant product, campaign, store, representative, or source
          through which your inquiry was generated so that we can provide an
          appropriate response.
        </p>

        <p>
          We will not use this provision to disregard a customer’s valid
          request not to receive further calls. If you do not wish to receive
          sales or follow-up calls from Great Eastern, you may request
          cessation of such calls by contacting us at{" "}
          <a href="mailto:postman@greateastern.in">
            postman@greateastern.in
          </a>
          .
        </p>

        <p>
          Once a valid request to stop such calls is received and processed,
          Great Eastern will take reasonable steps to update its records and
          prevent further sales follow-up calls, subject to communications
          that may still be necessary for existing orders, services,
          warranties, financing, legal obligations, fraud prevention, or other
          legitimate operational purposes.
        </p>

        <h2>4. WhatsApp Communication & Customer Consent</h2>

        <p>
          Great Eastern Trading Co. provides WhatsApp-based communication for
          customer support, product inquiries, sales assistance, order
          servicing, and post-purchase assistance.
        </p>

        <ul>
          <li>
            Our official WhatsApp numbers are{" "}
            <strong>+918017353535</strong> (automated support bot) and{" "}
            <strong>+919147769878</strong> (order and service notifications).
          </li>

          <li>
            The WhatsApp bot assists with store location, product inquiries,
            service support, sales assistance, and general customer assistance.
          </li>

          <li>
            When you voluntarily initiate a conversation or submit your name,
            mobile number, or other information through our WhatsApp bot, you
            authorize Great Eastern to use that information to respond to your
            inquiry and provide related sales or customer assistance.
          </li>

          <li>
            Where you have initiated an inquiry or lead, we may follow up by
            telephone using the mobile number provided by you for the purpose
            of responding to that inquiry and assisting with your purchase or
            service requirement.
          </li>

          <li>
            After purchasing a product from our website or any physical store,
            we may contact you on the mobile number provided at the time of
            purchase for order servicing, delivery, installation, warranty,
            service, feedback, and other related purposes.
          </li>

          <li>
            We may send invoices, order confirmations, delivery updates,
            warranty/service reminders, feedback requests, and customer
            support messages through WhatsApp.
          </li>

          <li>
            We may also send promotional or offer-related communications where
            permitted by applicable law and regulatory requirements. You may
            request to opt out of promotional communications at any time.
          </li>

          <li>
            Your mobile number, responses, and interaction details may be
            securely stored for service records, sales follow-up, dispute
            resolution, compliance, analytics, and quality improvement.
          </li>

          <li>
            WhatsApp conversations are subject to WhatsApp's security and
            privacy infrastructure. Great Eastern may retain records of
            communications and related customer information within its own
            systems for legitimate business, legal, compliance, and
            operational purposes.
          </li>
        </ul>

        <h2>5. Advertising, Instagram & Digital Lead Generation</h2>

        <p>
          Great Eastern may use digital advertising platforms, social media
          platforms, Instagram, WhatsApp, websites, and online lead-generation
          tools to promote its products and services.
        </p>

        <p>
          If you voluntarily submit your name, phone number, email address, or
          other contact information through a Great Eastern advertisement,
          Instagram interaction, WhatsApp interaction, website form, campaign
          form, or other digital lead-generation mechanism, we may use the
          information to contact you regarding the inquiry, product, service,
          offer, campaign, or other subject for which the information was
          submitted.
        </p>

        <p>
          This may include a telephone call from Great Eastern or an authorized
          sales representative to understand your requirement, provide product
          information, discuss pricing or financing options, arrange a store
          visit, or assist you with completing your purchase.
        </p>

        <p>
          We may retain information relating to the source of a lead, such as
          the relevant campaign, advertisement, platform, store, or inquiry
          channel, for attribution, customer service, analytics, and
          operational purposes.
        </p>

        <h2>6. Sharing of Information</h2>

        <ul>
          <li>
            With trusted third-party service providers such as delivery
            partners, payment gateways, communication providers, IT service
            providers, CRM providers, cloud service providers, advertising
            platforms, and other vendors, strictly for legitimate business and
            operational purposes.
          </li>

          <li>
            With authorized Great Eastern sales representatives, branch
            personnel, service teams, or other personnel where necessary to
            respond to your inquiry or provide services.
          </li>

          <li>
            With financing partners if you opt for EMI, financing, or hire
            purchase schemes.
          </li>

          <li>
            With government, regulatory, law-enforcement, or other authorized
            authorities where required or permitted by applicable law.
          </li>

          <li>
            In connection with business operations, audits, legal proceedings,
            fraud prevention, or protection of Great Eastern's rights and
            property.
          </li>

          <li>
            We do not sell or rent your personal data to third parties.
          </li>
        </ul>

        <h2>7. Data Protection & Security</h2>

        <p>
          We implement reasonable technical and organizational measures to
          protect your personal information against unauthorized access,
          alteration, disclosure, loss, misuse, or destruction.
        </p>

        <p>
          While we strive to use appropriate security practices, no method of
          electronic transmission or storage is completely secure. Accordingly,
          we cannot guarantee absolute security of information transmitted to
          or stored by us.
        </p>

        <h2>8. Your Rights & Communication Preferences</h2>

        <p>You may:</p>

        <ul>
          <li>
            Request access to the personal data we hold about you, subject to
            applicable law.
          </li>

          <li>
            Request correction or updating of inaccurate or incomplete
            personal data.
          </li>

          <li>
            Request deletion of your personal data, subject to legal,
            contractual, financial, accounting, warranty, dispute-resolution,
            and other applicable retention requirements.
          </li>

          <li>
            Request to stop sales follow-up calls by contacting{" "}
            <a href="mailto:postman@greateastern.in">
              postman@greateastern.in
            </a>
            .
          </li>

          <li>
            Opt out of promotional communications, including promotional
            WhatsApp messages, SMS, emails, or other permitted promotional
            communications.
          </li>

          <li>
            Withdraw or modify applicable communication preferences where
            permitted by law.
          </li>
        </ul>

        <p>
          Requests to stop sales or promotional communications will not affect
          communications that are reasonably necessary to complete an existing
          order, provide an existing service or warranty, process financing,
          address a customer complaint, comply with legal obligations, or
          protect against fraud or unauthorized activity.
        </p>

        <h2>9. Cookies & Tracking Technologies</h2>

        <p>
          Our website may use cookies, pixels, analytics tools, and similar
          technologies to improve user experience, analyze traffic, measure
          advertising performance, personalize content, and understand how
          visitors interact with our services.
        </p>

        <p>
          Third-party advertising or analytics providers may independently
          process information according to their own privacy policies. You may
          disable cookies through your browser settings, although some website
          features may not function properly.
        </p>

        <h2>10. Retention of Data</h2>

        <p>We retain your information only for as long as reasonably necessary to:</p>

        <ul>
          <li>Provide products and services.</li>
          <li>Respond to and manage customer inquiries and leads.</li>
          <li>Complete sales and customer-service activities.</li>
          <li>Maintain sales, service, warranty, and financial records.</li>
          <li>Comply with legal and regulatory obligations.</li>
          <li>Resolve disputes and enforce agreements.</li>
          <li>Prevent fraud, misuse, or unauthorized activity.</li>
          <li>Maintain appropriate business and operational records.</li>
        </ul>

        <h2>11. Third-Party Links & Platforms</h2>

        <p>
          Our website, advertisements, WhatsApp communications, Instagram
          pages, or other digital communications may contain links to
          third-party websites, applications, or platforms.
        </p>

        <p>
          We are not responsible for the privacy practices, security, or
          content of third-party platforms. Customers should review the
          privacy policies and terms applicable to those platforms before
          providing information to them.
        </p>

        <h2>12. Updates to this Policy</h2>

        <p>
          We may update this Privacy Policy from time to time to reflect
          changes in our services, technology, business practices, or
          applicable legal and regulatory requirements.
        </p>

        <p>
          Any material changes will be posted on{" "}
          <strong>greateastern.in</strong> with the revised effective date.
        </p>

        <h2>13. Contact Us</h2>

        <p>
          If you have any questions, concerns, requests regarding your
          personal data, or wish to opt out of sales follow-up calls or
          promotional communications, please contact us at:
        </p>

        <p>
          <strong>Great Eastern Hire Purchase Private Limited</strong>
          <br />
          (Trade name: <strong>Great Eastern Trading Company</strong>)
          <br />
          Website:{" "}
          <a href="https://greateastern.in">greateastern.in</a>
          <br />
          Privacy / Customer Support Email:{" "}
          <a href="mailto:customercare@greateastern.in">
            customercare@greateastern.in
          </a>
          <br />
          Sales Call Opt-Out Email:{" "}
          <a href="mailto:postman@greateastern.in">
            postman@greateastern.in
          </a>
          <br />
          Phone: 033 4087 4444
          <br />
          Address: 20, Old Court House St, B.B.D. Bagh, Kolkata, West Bengal
          700001, India
        </p>

        <h2>14. Official Websites & Domain Verification</h2>

        <p>
          To protect customers from fraud, phishing, or impersonation, Great
          Eastern Trading Co. operates through the following official and
          verified domains:
        </p>

        <ul>
          <li>
            <strong>https://greateastern.in</strong>
          </li>
          <li>
            <strong>https://gret.co.in</strong>
          </li>
          <li>
            <strong>https://greateasterntrading.in</strong>
          </li>
          <li>
            <strong>https://getcoonline.in</strong>
          </li>
        </ul>

        <p>
          Any website, message, advertisement, or communication claiming to
          represent Great Eastern Trading Co. from domains other than those
          listed above should be treated with caution and may be unauthorized.
          Customers are advised not to share OTPs, payment details, passwords,
          or sensitive personal information outside our verified platforms.
        </p>
      </div>
    </div>
  );
}

